// extracted by mini-css-extract-plugin
export default {"container":"StoreSelect_container__M9SFa","trigger":"StoreSelect_trigger__KVhut","empty":"StoreSelect_empty__Ea8aj","icon":"StoreSelect_icon__usZoa"};